import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1554243359421163';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
function safeInitPixel() {
  try {
    if (typeof window === 'undefined') return;
    if (window.fbq) return;
    // Bootstrap fbq queue
    const fbq: any = function (...args: any[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args);
      } else {
        fbq.queue.push(args);
      }
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;
    if (!window._fbq) window._fbq = fbq;
    // Inject the external script defensively
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    // Silence cross-origin "Script error." if the script is blocked
    script.onerror = () => {
      // Swallow — adblockers or network failures should not break the app
    };
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }
    try {
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
    } catch (e) {
      // no-op
    }
  } catch (e) {
    // no-op
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Defer slightly so any third-party failures don't block initial render
    const timer = setTimeout(safeInitPixel, 100);
    return () => clearTimeout(timer);
  }, []);
  return <noscript data-id="element-20" data-mp="2145slb76o1db">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-21" data-mp="214p2q5qldlgs" />
    </noscript>;
}
export function trackInitiateCheckout(pack: 'profesional' | 'elite') {
  try {
    if (typeof window === 'undefined' || !window.fbq) return;
    window.fbq('track', 'InitiateCheckout', {
      content_name: pack === 'elite' ? 'Megapack Élite' : 'Pack Profesional',
      value: pack === 'elite' ? 27990 : 18990,
      currency: 'ARS'
    });
  } catch (e) {
    // no-op
  }
}